/**
 * @description 关系图的边
 */
import { __assign, __extends } from "tslib";
import Element from './base';
import EdgeShapeFactory from './shape/edge';
var Edge = /** @class */ (function (_super) {
    __extends(Edge, _super);
    function Edge(cfg) {
        var _this = _super.call(this, __assign({ type: 'edge', generatePoints: true, shapeType: 'edge', shareTooltip: false }, cfg)) || this;
        _this.set('shapeFactory', EdgeShapeFactory);
        return _this;
    }
    return Edge;
}(Element));
export default Edge;
//# sourceMappingURL=edge.js.map